import { LoaderFunctionArgs } from "react-router-dom";
import {apiEndpoints} from "@/services/api/api.ts";
import {AdminPanelCategoryData} from "@/routes/adminPanel/categories/main/types/adminPanelCategoryData.ts";

export async function adminPanelCategoryEditLoader({
                                       params,
                                   }: LoaderFunctionArgs): Promise<AdminPanelCategoryData> {
    try {
        if (!params.categoryId) {
            return {} as AdminPanelCategoryData;
        }

        const response = await apiEndpoints.getCategoryById(params.categoryId);
        return response.data;
    } catch (error) {
        throw new Error(error instanceof Error ? error.message : "Unknown error");
    }
}
